export const environment = {
  production: false,
  dev: false,
  apiBaseUrl: 'https://apidev.registrofotografico.gctweb.com.br',
  graphQLUri: 'https://apidev.registrofotografico.gctweb.com.br/graphql',
  subscriptionsUri: 'wss://apidev.registrofotografico.gctweb.com.br/subscriptions',
  restUri: 'https://apidev.registrofotografico.gctweb.com.br',
  googleMapsKey: 'AIzaSyAz07kX4j7oISPSjz8h0-QoBkvkB4hGMsg',
  openStreetMapUrl: 'https://nominatim.openstreetmap.org/search.php?q={query}&polygon_geojson=1&format=json'
};
